export const css = {
	root: '_3iYFOlOW',
	clear: 'Q3tGkg5b',
	player: '_2yTiosAV',
	playlist: '_7RQpeOFB',
	playlistTitle: '_243V3Co1',
	playlistItem: '_3yI1dQXI',
	' _key': 'apic-theme/apic/audio/audio'
};

export default css;
